export const DESK_PLAN_HASH = '#desk';
export const COUNQUER_PLAN_HASH = '#conquer';
